import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getArticles, getAds, getCategories } from "../lib/api";
import { FeatureArticle, ArticleCard, SectionHeading } from "../components/ArticleCard";
import { AdSlot, LeaderboardAd, NativeAd } from "../components/Ads";
import SocialFeed from "../components/SocialFeed";
import SectionSponsor from "../components/SectionSponsor";
import ScoreboardWidget from "../components/ScoreboardWidget";

export default function Category() {
  const { slug } = useParams();
  const [articles, setArticles] = useState([]);
  const [cat, setCat] = useState(null);
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getArticles({ category: slug, limit: 100 }).then(setArticles).catch(() => {}).finally(() => setLoading(false));
    getCategories().then((cats) => setCat(cats.find((c) => c.slug === slug))).catch(() => {});
    getAds().then(setAds).catch(() => {});
  }, [slug]);

  const leaderboard = ads.find((a) => a.slot === "leaderboard");
  const sidebarAds = ads.filter((a) => a.slot === "sidebar");
  const nativeAd = ads.find((a) => a.slot === "native");
  const [lead, ...rest] = articles;

  return (
    <div className="paper-texture min-h-screen">
      <div className="border-b border-[var(--paper-border)] bg-[var(--navy)]">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-4 py-10">
          <div>
            <p className="eyebrow text-[var(--gold)]">Section</p>
            <h1 className="font-display text-4xl font-extrabold text-white sm:text-5xl">{cat?.name || slug}</h1>
            {cat?.tagline && <p className="font-serif-body mt-2 text-white/80">{cat.tagline}</p>}
          </div>
          <SectionSponsor section={slug} />
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4 py-5">{leaderboard && <LeaderboardAd ad={leaderboard} />}</div>

      <div className="mx-auto grid max-w-7xl gap-10 px-4 pb-10 lg:grid-cols-12">
        <div className="lg:col-span-8">
          {loading ? (
            <p className="font-ui py-20 text-center text-slate-500">Loading stories…</p>
          ) : articles.length === 0 ? (
            <p className="font-ui py-20 text-center text-slate-500">No articles yet in this section.</p>
          ) : (
            <>
              {lead && <FeatureArticle article={lead} />}
              {nativeAd && <div className="my-8"><NativeAd ad={nativeAd} /></div>}
              <div className="mt-10 grid gap-8 sm:grid-cols-2">
                {rest.map((a) => <ArticleCard key={a.slug} article={a} />)}
              </div>
            </>
          )}
        </div>

        <aside className="lg:col-span-4">
          <div className="sticky top-40 space-y-6">
            {slug === "sports" && <ScoreboardWidget />}
            {sidebarAds[0] && <AdSlot ad={sidebarAds[0]} className="rounded-lg" />}
            <SocialFeed />
            {sidebarAds[1] && <AdSlot ad={sidebarAds[1]} className="rounded-lg" />}
          </div>
        </aside>
      </div>
    </div>
  );
}
